import {
    CategorieDArticleApi,
    CategorieDArticleJsonldCategorieArticleAll,
} from '@europrocurement/l2d-domain/openApi/ApiOffre';
import { articleIcon } from '@europrocurement/l2d-icons';
import { DataSourcesThunksType } from '@europrocurement/l2d-redux-utils';

import { type ModelConfiguration, type ModelMethods, type ModelItem } from '../../..';
import { ArticleCategorySelector } from '../selectors';
import { ARTICLES_CATEGORIES_SLICE_NAME } from '../constants';

const modelKey = 'article_category';
const modelName = 'ArticleCategory';
const sliceName = ARTICLES_CATEGORIES_SLICE_NAME;

type ModelStructure = CategorieDArticleJsonldCategorieArticleAll;

const methods: ModelMethods<ModelStructure> = {
    getItemDefaultLabel: (model: ModelStructure) => `${model.libelle}`,
};

export type ArticleCategoryEndpoints = {
    list: InstanceType<typeof CategorieDArticleApi>['apiCategoriesArticlesGetCollection'];
    delete: InstanceType<typeof CategorieDArticleApi>['apiCategoriesArticlesIdDelete'];
    read: InstanceType<typeof CategorieDArticleApi>['apiCategoriesArticlesIdGet'];
    update: InstanceType<typeof CategorieDArticleApi>['apiCategoriesArticlesIdPut'];
    create: InstanceType<typeof CategorieDArticleApi>['apiCategoriesArticlesPost'];
};

export type ArticleCategoryModel = ModelItem<ModelStructure> & ArticleCategoryEndpoints;

export const buildArticleCategoryModel = (
    api: CategorieDArticleApi,
    datasourcesThunks: DataSourcesThunksType<CategorieDArticleJsonldCategorieArticleAll>,
) => {
    const configuration: ModelConfiguration = {
        key: modelKey,
        name: modelName,
        type: "Catégorie d'article",
        sliceName,
        selector: ArticleCategorySelector,
        api,
        datasourcesThunks,
        icon: articleIcon,
    };

    const endpoints: ArticleCategoryEndpoints = {
        list: api.apiCategoriesArticlesGetCollection.bind(api),
        delete: api.apiCategoriesArticlesIdDelete.bind(api),
        read: api.apiCategoriesArticlesIdGet.bind(api),
        update: api.apiCategoriesArticlesIdPut.bind(api),
        create: api.apiCategoriesArticlesPost.bind(api),
    };

    const model: ArticleCategoryModel = {
        ...configuration,
        ...methods,
        ...endpoints,
    };

    return model;
};
